import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../../store/user";
import axios from "axios";
import { useEffect, useState } from "react";
import { EMenuActions } from "../../store";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";




const ViewOrder = () => {
  const order = useSelector((state) => state.User.order);
  const token = useSelector((state) => state.Company.auth_token);
  const C_URL = useSelector((state) => state.Company.c_url);
  const dispatch = useDispatch();
  const waiterScreen = useLocation().pathname.split("/")[2];
console.log(waiterScreen)
const [wId, setWID] = useState();
  const [loading, setLoading] = useState();
  const [wIdreq, setWIdreq] = useState(false);
  const c_url = useSelector((state) => state.Company.c_url);
  const auth_token = useSelector((state) => state.Company.auth_token);

  // console.log(token);
  useEffect(() => {
    const storedEmail = localStorage.getItem("user-email");
    const userObject = JSON.parse(localStorage.getItem("waiterId") || "[]");
  const userId = userObject[0]?.UserId;
  console.log(userId)

    const fetchOrder = async () => {
      try {
        let response;
        if (waiterScreen === "waiterscreen") {
          // Fetch orders by waiter ID
          response = await axios.get(
            `https://${C_URL}/api/v1/Orders/ByWaiterId/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } else {
        response = await axios.get(
          `https://${C_URL}/api/v1/Orders/ByCustomerEmail/${storedEmail}`,
          {
              headers: {
                Authorization: `Bearer ${token}`,
              },
          }
        );
      }
      console.log(response)
        if (response.data.length === 0) {
          throw new Error("No orders found");
        }
        dispatch(UserActions.setOrder(response.data));
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching order:", error);
        dispatch(UserActions.setOrder([]));
      }
    };
    fetchOrder();
  }, [dispatch, token]);

  // const showDetails = (orderItems) => {
  //   console.log(orderItems);
  //   dispatch(EMenuActions.setOrderDetails(orderItems));
  //   dispatch(EMenuActions.setViewItems(true));
  // };
 

const showDetails = async (orderNo) => {
  try {
    const apiUrl = `https://demo.cranesoft-digitalmenu.com/api/v1/Order/${orderNo}`;
    
    const response = await axios.get(apiUrl,  {
      headers: {
        'Authorization': `Bearer ${token}`, 
      },
    });
    
    console.log(response.data);

    // Dispatch actions to Redux
    dispatch(EMenuActions.setOrderDetails(response.data));
    dispatch(EMenuActions.setViewItems(true));
  } catch (error) {
    console.error('Error fetching order details:', error);
  }
};


  const totalAmount = order
    ? order
        ?.reduce((sum, item) => {
          const totalAmount = item.orderInfo?.TotalAmount;
          return sum + (totalAmount ? Number(totalAmount) : 0);
        }, 0)
        .toLocaleString("en-NG", {
          style: "currency",
          currency: "NGN",
        })
    : "0";

  return (
    <div className="relative w-full h-[100vh] md:pb-2 m-auto bg-white">
      <div className="flex w-full justify-center text-center items-center h-[10vh]">
        <h1 className="text-md font-black">View Your Order</h1>
      </div>
      <hr className="w-full" />
      {order && order.length > 0 ? (
        <ul className="min-md:p-3 overflow-y-auto h-[70vh] scroll-smooth mb-3">
          {order.map((item, index) => (
            <div key={index} className="border-primaryLight/70">
              <li
                key={index}
                className="bg-white md:w-[100%] md:m-auto md:hover:shadow-xl transition-shadow delay-75 md:border md:border-dark/10 md:hover:border-dark/0 hover:shadow-dark/10 md:p-3 max-md:p-2 grid grid-cols-3 max-sm:grid-cols-3 md:grid-cols-6 items-center"
              >
                {/* Date */}
                <p className="font-normal text-secondary text-left text-sm">
                  {new Date(item.orderInfo?.OrderDate).toLocaleDateString(
                    "en-GB"
                  )}
                </p>
                {/* Order No */}
                <p className="font-normal max-sm:hidden text-secondary text-left text-sm">
                  {item.orderInfo?.OrderNo}
                </p>
                {/* Table No */}
                <p className="font-normal max-sm:text-center text-secondary text-left text-sm">
                  {item.orderInfo?.TableNumber ?? "N/A"}
                  </p>
                {/* Total Amount (hidden on small screens) */}
                <p className="text-sm text-start max-md:hidden">
                  {Number(item.orderInfo?.TotalAmount || 0).toLocaleString(
                    "en-NG",
                    {
                      style: "currency",
                      currency: "NGN",
                    }
                  )}
                </p>
                   {/* Order Status */}
                <p className="font-normal max-sm:text-center text-secondary text-left text-sm">
                  {item.orderInfo?.StatusName ?? "N/A"}
                </p>
                {/* View Order Button */}
                <button
                  className="btn bg-secondary w-full whitespace-nowrap md:w-[80%] hover:bg-secondary/70 rounded py-1 btn-sm text-white cursor-pointer"
                  onClick={() => showDetails(item.orderInfo?.id)}
                >
                  View Order
                </button>
              </li>
            </div>
          ))}
        </ul>
      ) : (
        <p className="text-center text-gray-500">No orders found.</p>
      )}
      <hr className="w-full " />
      <div className="flex w-full justify-end text-center items-center h-[10vh] px-24">
        <h1 className="text-md font-black">Total</h1>
        <p className="ml-5 font-black">{totalAmount}</p>
      </div>
    </div>
  );
};

export default ViewOrder;
